import { useMutation } from '@tanstack/react-query';

import { DisplaySettingCreateFormSchemaValues } from 'src/features/systems/utils/displaySettingFormSchema';
import { SystemSettingCreateFormSchemaValues } from 'src/features/systems/utils/formSchema';
import { SystemSettings } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/system/setting/`;

type DTO = (SystemSettingCreateFormSchemaValues | DisplaySettingCreateFormSchemaValues) & { parkingId: string };

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<SystemSettings> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSystemSetting };
